import { Contract, ContractId } from 'shared/models';

export const Actions = {
    CACHE_CONTRACTS: 'CACHE_CONTRACTS',
    CACHE_CONTRACT_LOCK_STATE: 'CACHE_CONTRACT_LOCK_STATE',
};

export const cacheContracts = (payload: Record<ContractId, Contract>) => ({
    type: Actions.CACHE_CONTRACTS,
    payload,
});

export const cacheContractLockState = (contractId: ContractId, meta: { locked: boolean }) => ({
    type: Actions.CACHE_CONTRACT_LOCK_STATE,
    payload: contractId,
    meta,
});
